import React from 'react';
import SideBar from '../../components/modules/left_sidebar';
import NavBar from '../../components/common/navbar';
import DashBoardComponent from '../../components/MainPageComponent/dashboard'
import DashBoardFilter from '../../components/MainPageComponent/dashboard_filter';
import Boletim_filter from '../../components/MainPageComponent/Boletim_filter';

const optionMenuArray =
{
    linkData: {
        filters: {
            Tabs: {
                Período: [
                    {
                        key: 'RangePicker',
                        displayKey: "intervalo de datas",
                        inputType: "RangePicker"
                    }
                ]
            },
            checkbox: []
        },
        navbarOptionsYear: false,
        tableName: "Boletim",
        nevdropdown: ["Abertura", "Fecho"],
        nevdroplabel: "",
        nevdropplaceholder: "Aberta",
        TitleBarpath:"/boletim_Form",
        TitleBartitle: "Boletim",
        prevPageName: "",
        prevPageLink: "",
        currentPath: "revenue_receitas",
        popUpTabName: "Consultar Conta",
        nevOptionSubMenu: {
            "Recibo": [
                {
                    name: 'Emissão de Recibos de Adiantamento',
                    url: 'revenue_receitas',
                    tableName: "BoletimEmissãodeRecibos",
                },
                {
                    name: 'Recibos de Adiantamento',
                    url: 'revenue_receitas',
                    tableName: "BoletimRecabo",
                }
            ]
        },
        nevOptionChange: [

            {
                name: 'Consulta de Conta corrente',
                url: 'revenue_receitas',
                tableName: "BoletimContacorrente",
            },
            {
                name: 'Faturas',
                url: 'revenue_receitas',
                tableName: "BoletimFaturas",
            },

        ],
        TitleBarlogo: "parcelas",
    }
}

class Boletim extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        this.setState(this.setLinkDataMethod())
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (prevProps) => {
        const parsed = this.props.location.state && this.props.location.state.paramoption || {};
        let prevParsed = prevProps.location.state && prevProps.location.state.paramoption || {}
        if (prevParsed.name !== parsed.name && (!parsed.tableName || parsed.back || this.state.search !== window.location.search || this.state.tableName !== parsed.tableName)) {
            this.setState(this.setLinkDataMethod())
        }
    }
    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
    setLinkDataMethod = () => {
        let parsed = this.props.location.state && this.props.location.state.paramoption || {}
        if (Object.keys(parsed).length === 0 && this.state && this.state.parsed) {
            parsed = this.state.parsed
        }
        if (parsed.back) {
            parsed = {}
        }
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
        if (topBarMenu) {
            this.setState({ topBarMenu })
        }
        if (parsed) {
            this.setState({ parsed })
        }
        let selectOption = { ...optionMenuArray };
        let linkData = selectOption.linkData;
        if (!parsed.name) {
            linkData.prevPageName = "";
            linkData.prevPageLink = "";
            linkData.tableName = "Parcel"
        }
        parsed.name = parsed.name ? parsed.name : ""
        parsed.url = parsed.url ? parsed.url : ""
        parsed.tableName = parsed.tableName ? parsed.tableName : ""
        if (parsed.name) {
            linkData.prevPageName = parsed.name;
            linkData.prevPageLink = parsed.url;
            linkData.tableName = parsed.tableName;
        }

        return {
            noOption: true,
            popUpForm: null,
            linkData: linkData,
            pageOption: "",
            Tab: null,
            parsed: parsed,
            tableName: linkData.tableName,
            search: window.location.search,
            topBarMenu: topBarMenu
        }
    }

    /* Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */

    changeOption = (prevPageName, prevPageLink) => {
        let linkData = { ...this.state.linkData }
        linkData.prevPageName = prevPageName;
        linkData.prevPageLink = prevPageLink;
        // console.log("OKOK");
        this.setState({
            linkData
        })
    }

    /*  Para renderizar o conteúdo html da página   */
    render() {
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu || this.state.topBarMenu
        return (
            <div className="dashboard">
                <NavBar
                    date={new Date()}
                    linkData={this.state.linkData}
                    topBarMenuOption={topBarMenu}
                    noOption={this.state.noOption}
                    moduleName="parcelas"
                    updateNavDropdown={(_row) => this.updateNavDropdown(_row)}
                />
                <SideBar />
                <Boletim_filter 
                 date={new Date()}
                 parsed={this.state.parsed}
                 topBarMenuOption={topBarMenu}
                 optionMenuArray={optionMenuArray}
                 linkData={this.state.linkData}
                 tab={"Boletim"}
                />
            </div>
        )
    }
}

export default Boletim;